import { Heading, Switch } from '@restworld/ui-ds-base';

import { useWorkerExperienceToggle } from './hooks/use-worker-experience-toggle';
import { useProfileCommonIntl } from './hooks';
import { useFetchWorkerData } from '../../hooks';
import { cn } from '@restworld/utils-common';

export function WorkerExperienceToggle() {
  const hasNoExperience = useFetchWorkerData();
  const { mutate: toggleExperience } = useWorkerExperienceToggle();
  const { noExperienceText } = useProfileCommonIntl();

  return (
    <StyledContainer>
      <Heading>{noExperienceText}</Heading>
      <Switch checked={hasNoExperience?.new_to_sector_having_no_experience} onChange={toggleExperience} />
    </StyledContainer>
  );
}

const StyledContainer = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex items-center gap-4 pb-4 pt-6', className)} {...props} />
);
